module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الإهـداء"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإهـداء")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أهدي هذا الكتاب في المقدمة للوعي الروحي لوالدي السيد سامح حجازين الذي فارق")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جسده الحياة لهذا العالم بتاريخ 23/11/2019، حيث قطعتُ أمامه "), _c('strong', [_vm._v("الوعد")]), _vm._v(" قبل ثلاثة أيام من وفاته بأنني سأكون مصدر فخره في يوم "), _c('br'), _c('br'), _vm._v("ما وها هو هذا اليوم قد جاء، وأعلم بأنه يشعر بالفخر بي الآن في مكان ما.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أهدي كتابي أيضاً لأفراد عائلتي ولأصدقائي جميعاً الذين هم من أهم محاور فرحي واهتمامي على الدوام.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9da684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 66
// module chunks = 0